import React from 'react';
import { DashboardIcon, SideMenuCancelReasonsIcon, SideMenuChangePasswordIcon, SideMenuHomePageSettingsIcon, SideMenuManageAdminIcon, SideMenuManageCategoriesIcon, SideMenuManageCurrencyIcon, SideMenuManageFaresIcon, SideMenuManageLocationsIcon, SideMenuManageSubCategoriesIcon, SideMenuManageUsersIcon, SideMenuMobileAppSettingsIcon, SideMenuPaymentMethodIcon, SideMenuPrecautionNotificationIcon, SideMenuPromoCodeIcon, SideMenuServiceProvidersIcon, SideMenuSiteConfigurationIcon, SideMenuSiteSettingsIcon, SideMenuSmsMethodIcon, SideMenuSubArrow } from "../components/Common/Assets/SVGIcon/SiteAdminIcon.js";
import { SideMenuCancelledJobsIcon, SideMenuCompletedJobsIcon, SideMenuContentManageMentIcon, SideMenuManageFailedPayoutIcon, SideMenuManageJobsIcon, SideMenuManagePayoutIcon, SideMenuManualJobsIcon, SideMenuScheduleJobsIcon, SideMenuSendNotificationsIcon, SideMenuStaticContentManageMentIcon, SideMenuTrackingIcon, SideMenuViewJobRatingsIcon } from '../components/Common/Assets/SVGIcon/SideMenuIconsRemaining.js';


const getDashboardSideMenu = [
    {
        label: "manageDashboard",
        activePaths: ["/siteadmin"],
        href: "/siteadmin",
        icon: <DashboardIcon />,
        isValidatePrivilege: false
    }
];

const getConfigurationSideMenu = [
    {
        label: "siteSettings",
        activePaths: ["/siteadmin/settings/site"],
        href: "/siteadmin/settings/site",
        icon: <SideMenuSiteSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },

    {
        label: "manageSiteConfig",
        activePaths: ["/siteadmin/settings/config"],
        href: "/siteadmin/settings/config",
        icon: <SideMenuSiteConfigurationIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },

    {
        label: "mobileSettings",
        activePaths: ["/siteadmin/settings/mobile-app"],
        href: "/siteadmin/settings/mobile-app",
        icon: <SideMenuMobileAppSettingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 1,
    },

    {
        label: "manageCurrency",
        activePaths: ["/siteadmin/currency"],
        href: "/siteadmin/currency",
        icon: <SideMenuManageCurrencyIcon />,
        isValidatePrivilege: true,
        privilegeId: 23,
    },


    {
        label: "managePaymentGateWay",
        activePaths: ["/siteadmin/payment-gateway"],
        href: "/siteadmin/payment-gateway",
        icon: <SideMenuPaymentMethodIcon />,
        isValidatePrivilege: true,
        privilegeId: 21,
    },
    {
        label: "manageSmsMethod",
        activePaths: ["/siteadmin/sms-method"],
        href: "/siteadmin/sms-methods",
        icon: <SideMenuSmsMethodIcon />,
        isValidatePrivilege: true,
        privilegeId: 19,
    },

    {
        label: "HomeSiteSettings",
        activePaths: ["/siteadmin/homepage/banner", "/siteadmin/homepage/category", "/siteadmin/homepage/top-feature",
            "/siteadmin/homepage/user", "/siteadmin/homepage/partner", "/siteadmin/homepage/footer", "/siteadmin/homepage/top-feature/add"
        ],
        href: "/siteadmin/homepage/banner",
        icon: <SideMenuHomePageSettingsIcon />,
        isValidatePrivilege: true,
        isAccordion: true,
        privilegeId: 2,
        data: [
            {
                label: "homeSectionSettings",
                activePaths: ["/siteadmin/homepage/banner"],
                href: "/siteadmin/homepage/banner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "citySectionSettings",
                activePaths: ["/siteadmin/homepage/category"],
                href: "/siteadmin/homepage/category",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "aboutSectionSettings",
                activePaths: ["/siteadmin/homepage/top-feature"],
                href: "/siteadmin/homepage/top-feature",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "safetySectionSettings",
                activePaths: ["/siteadmin/homepage/user"],
                href: "/siteadmin/homepage/user",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "signupSectionSettings",
                activePaths: ["/siteadmin/homepage/partner"],
                href: "/siteadmin/homepage/partner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
            {
                label: "footerSectionSettings",
                activePaths: ["/siteadmin/homepage/footer"],
                href: "/siteadmin/homepage/footer",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 2
            },
        ]
    },

    {
        label: "precautionNotification",
        activePaths: ["/siteadmin/precaution-notification"],
        href: "/siteadmin/precaution-notification",
        icon: <SideMenuPrecautionNotificationIcon />,
        isValidatePrivilege: true,
        privilegeId: 18,
    },

]

const getAdminUserSideMenu = [
    {
        label: "manageAdmin",
        activePaths: ["/siteadmin/admin-users", "/siteadmin/admin-roles"],
        icon: <SideMenuManageAdminIcon />,
        isValidatePrivilege: true,
        isAccordion: true,
        isSuperAdmin: true,

        data: [
            {
                label: "manageAdminUsers",
                activePaths: ["/siteadmin/admin-users"],
                href: "/siteadmin/admin-users",
                icon: <SideMenuSubArrow />,
            },
            {
                label: "manageAdminRoles",
                activePaths: ["/siteadmin/admin-roles"],
                href: "/siteadmin/admin-roles",
                icon: <SideMenuSubArrow />,

            }
        ]
    },
    {
        label: "changePassword",
        activePaths: ["/siteadmin/change/admin"],
        href: "/siteadmin/change/admin",
        icon: <SideMenuChangePasswordIcon />,
        isValidatePrivilege: false
    }
]

const getUserSideMenu = [
    {
        label: "usersMenu",
        activePaths: ["/siteadmin/users"],
        href: "/siteadmin/users",
        icon: <SideMenuManageUsersIcon />,
        isValidatePrivilege: true,
        privilegeId: 3,
    },

    {
        label: "partnerMenu",
        activePaths: ["/siteadmin/partners"],
        href: "/siteadmin/partners",
        icon: <SideMenuServiceProvidersIcon />,
        isValidatePrivilege: true,
        privilegeId: 4,
    }
];

const getOpConfiguration = [
    {
        label: "categoryMenu",
        activePaths: ["/siteadmin/category"],
        href: "/siteadmin/category",
        icon: <SideMenuManageCategoriesIcon />,
        isValidatePrivilege: true,
        privilegeId: 5,
    },

    {
        label: "subCategoryMenu",
        activePaths: ["/siteadmin/sub-category"],
        href: "/siteadmin/sub-category",
        icon: <SideMenuManageSubCategoriesIcon />,
        isValidatePrivilege: true,
        privilegeId: 6,
    },
    {
        label: "location",
        activePaths: ["/siteadmin/location", '/siteadmin/edit-location/', '/siteadmin/add-location'],
        href: "/siteadmin/location",
        icon: <SideMenuManageLocationsIcon />,
        isValidatePrivilege: true,
        privilegeId: 7,
    },

    {
        label: "manageFare",
        activePaths: ["/siteadmin/pricing"],
        href: "/siteadmin/pricing/list",
        icon: <SideMenuManageFaresIcon />,
        isValidatePrivilege: true,
        privilegeId: 8,
    },
    {
        label: "managePromoCode",
        activePaths: ["/siteadmin/promo-code"],
        href: "/siteadmin/promo-code/list",
        icon: <SideMenuPromoCodeIcon />,
        isValidatePrivilege: true,
        privilegeId: 12,
    },
    {
        label: "manageCancelReason",
        activePaths: ["/siteadmin/cancel-reasons"],
        href: "/siteadmin/cancel-reasons",
        icon: <SideMenuCancelReasonsIcon />,
        isValidatePrivilege: true,
        privilegeId: 14,
    }
];

const getJobsSideMenu = [
    {
        label: "manualBookings",
        activePaths: ["/siteadmin/manual-bookings"],
        href: "/siteadmin/manual-bookings",
        icon: <SideMenuManualJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 22,
    },

    {
        label: "bookingsMenu",
        activePaths: ["/siteadmin/jobs"],
        href: "/siteadmin/jobs",
        icon: <SideMenuManageJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },
    {
        label: "manageSchedule",
        activePaths: ["/siteadmin/schedule-jobs"],
        href: "/siteadmin/schedule-jobs",
        icon: <SideMenuScheduleJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },

    {
        label: "manageCompletedBooking",
        activePaths: ["/siteadmin/completed-jobs"],
        href: "/siteadmin/completed-jobs",
        icon: <SideMenuCompletedJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9,
    },

    {
        label: "manageCancelledBookings",
        activePaths: ["/siteadmin/cancelled-jobs"],
        href: "/siteadmin/cancelled-jobs",
        icon: <SideMenuCancelledJobsIcon />,
        isValidatePrivilege: true,
        privilegeId: 9
    }

];

const payoutSideMenu = [
    {
        label: "managePayout",
        activePaths: ["/siteadmin/payout"],
        href: "/siteadmin/payout",
        icon: <SideMenuManagePayoutIcon />,
        isValidatePrivilege: true,
        privilegeId: 15
    },

    {
        label: "manageFailedPayout",
        activePaths: ["/siteadmin/failed-payout"],
        href: "/siteadmin/failed-payout",
        icon: <SideMenuManageFailedPayoutIcon />,
        isValidatePrivilege: true,
        privilegeId: 15
    }
];

const monitorSideMenu = [
    {
        label: "tracking",
        activePaths: ["/siteadmin/tracking"],
        href: "/siteadmin/tracking",
        icon: <SideMenuTrackingIcon />,
        isValidatePrivilege: true,
        privilegeId: 20
    },

    {
        label: "ratings",
        activePaths: ["/siteadmin/ratings"],
        href: "/siteadmin/ratings",
        icon: <SideMenuViewJobRatingsIcon />,
        isValidatePrivilege: true,
        privilegeId: 11
    }
]

const announcementSideMenu = [

    {
        label: "manageNotifications",
        activePaths: ["/siteadmin/notifications"],
        href: "/siteadmin/notifications",
        icon: <SideMenuSendNotificationsIcon />,
        isValidatePrivilege: true,
        privilegeId: 13
    },
]


const contentSideMenu = [

    {
        label: "contentpageManagement",
        activePaths: ["/siteadmin/contentpage"],
        href: "/siteadmin/contentpage/manage",
        icon: <SideMenuContentManageMentIcon />,
        isValidatePrivilege: true,
        privilegeId: 17,
    },

    {
        label: "staticpageManagement",
        activePaths: ["/siteadmin/staticpage"],
        href: "/siteadmin/staticpage/manage",
        icon: <SideMenuStaticContentManageMentIcon />,
        isValidatePrivilege: true,
        privilegeId: 16,
    },
]



export {
    getDashboardSideMenu,
    getConfigurationSideMenu,
    getAdminUserSideMenu,
    getUserSideMenu,
    getOpConfiguration,
    getJobsSideMenu,
    payoutSideMenu,
    monitorSideMenu,
    announcementSideMenu,
    contentSideMenu
}

